import React from "react";
import gridIcon from "../../../Assets/images/grid-icon.svg";
import listIcon from "../../../Assets/images/list-icon.svg";
import { LanguageConstants } from "../../../constants/LanguageConstants";
import { changeLanguage } from "../../../utils/Helper";

export type QuotationItemsToolbarProps = {
  itemSearch: string;
  onItemSearchChange: (value: string) => void;
  viewMode: "list" | "grid";
  onViewModeChange: (mode: "list" | "grid") => void;
  /** When true, purple header + “Found N items” (search results layout). */
  searchActive?: boolean;
  resultCount?: number;
  loading?: boolean;
  listSection?: boolean;
};

function formatFoundItemsLabel(count: number): string {
  const spa = changeLanguage() === "spa";
  if (spa) {
    return count === 1 ? "Se encontró 1 Item" : `Se encontraron ${count} Items`;
  }
  return count === 1 ? "Found 1 item" : `Found ${count} items`;
}

/**
 * Stable search + view toggle — must stay mounted while typing (do not swap with a second input).
 */
export function QuotationItemsToolbar({
  itemSearch,
  onItemSearchChange,
  viewMode,
  onViewModeChange,
  searchActive = false,
  resultCount = 0,
  loading = false,
  listSection = false,
}: QuotationItemsToolbarProps) {
  const searchPlaceholder =
    LanguageConstants?.VIEW_QUOTE_SEARCH_ITEMS ?? "Search items";

  const headClass = searchActive
    ? "vq__searchModeHead"
    : `vq__toolbar${listSection ? " px-0 border-0 pb-0" : ""}`;

  return (
    <div
      className={
        searchActive
          ? `vq__searchModeHeadWrap${loading ? " vq__searchModeHeadWrap--dim" : ""}`
          : undefined
      }
    >
      <div className={headClass}>
        <div className={`vq__search${searchActive ? " vq__search--inPanel" : ""} input-search-new`}>
          <i className="icon-search" aria-hidden />
          <input
            type="search"
            value={itemSearch}
            onChange={(e) => onItemSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
          />
        </div>
        {viewMode === "grid" ? (
          <button type="button" className="vq__toggle" onClick={() => onViewModeChange("list")}>
            <img src={listIcon} alt="" />
            {LanguageConstants?.LIST_VIEW ?? "List View"}
          </button>
        ) : (
          <button type="button" className="vq__toggle" onClick={() => onViewModeChange("grid")}>
            <img src={gridIcon} alt="" />
            {LanguageConstants?.GRID_VIEW ?? "Grid View"}
          </button>
        )}
      </div>
      {searchActive ? (
        <p className="vq__searchModeCount" role="status">
          {formatFoundItemsLabel(resultCount)}
        </p>
      ) : null}
    </div>
  );
}
